<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'VideoCateCenter', to: { path: '/video-category' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>[Video/Weninar]分類</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toVideoCategoryCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增分類</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <VideoCategoryCenterTable></VideoCategoryCenterTable>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import VideoCategoryCenterTable from '@/views/E-6__SupportVideos/c/VideoCateCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    VideoCategoryCenterTable,
  },
  created() {
    this.clear();
    this.getVideoCateList();
  },
  methods: {
    ...mapActions('videocate', {
      getVideoCateList: 'find',
      clear: 'clear',
    }),
    toVideoCategoryCreate() {
      this.$router.push('/video-category/create');
    },
  },
};
</script>

<style></style>
